import { render, staticRenderFns } from "./BrebImg.vue?vue&type=template&id=5381586a&scoped=true&"
import script from "./BrebImg.vue?vue&type=script&lang=js&"
export * from "./BrebImg.vue?vue&type=script&lang=js&"
import style0 from "./BrebImg.vue?vue&type=style&index=0&id=5381586a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5381586a",
  null
  
)

export default component.exports